export default __webpack_public_path__ + "static/media/sports_baseball.92aba0ee.svg";